import React from 'react'
import MyAccPaymentComp from '../../components/Account/MyAccPaymentComp'

const MyAccPayment = () => {
  return (
    <>
        <MyAccPaymentComp/> 
    </>
  )
}

export default MyAccPayment